import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function SystemParams() {
  const [config, setConfig] = useState({});
  useEffect(() => {
    axios.get('/api/system/config').then(res => setConfig(res.data));
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 text-white p-8">
      <h1 className="text-3xl font-bold mb-6">系统参数与配置 (不易·五维约束)</h1>
      <div className="grid grid-cols-2 gap-6">
        <div className="bg-gray-800 p-6 rounded-lg">
          <h2 className="text-xl mb-4">五维约束</h2>
          {config.five_dimension && Object.entries(config.five_dimension).map(([k,v]) => (
            <div key={k} className="mb-2"><span className="text-gray-400">{k}:</span> {v}</div>
          ))}
        </div>
        <div className="bg-gray-800 p-6 rounded-lg">
          <h2 className="text-xl mb-4">系统架构</h2>
          {config.architecture && Object.entries(config.architecture).map(([k,v]) => (
            <div key={k} className="mb-2"><span className="text-gray-400">{k}:</span> {v.component}</div>
          ))}
        </div>
        <div className="bg-gray-800 p-6 rounded-lg col-span-2">
          <h2 className="text-xl mb-4">API 模型配置</h2>
          <pre className="text-xs text-green-400">{JSON.stringify(config.api_models, null, 2)}</pre>
        </div>
      </div>
    </div>
  );
}
